import React, { useState} from 'react'
import { translate, classConvert } from '../../assets/js/functions';
import { domain } from "../../assets/js/api";
import { Link } from 'react-router-dom'
import parse from 'html-react-parser';

import IcoNext from "../../assets/img/ico-anterior.svg"
import IcoPrev from "../../assets/img/ico-seguent.svg"


export default function ViewGalleryMobile({group, gallery}) {
    //const [galleryOpen, setGalleryOpen] = useState(false);
    const [galleryElem, setGalleryElem] = useState(null);

    function prevImg() {
        let index = galleryElem - 1;
        if (index < 0) {
            index = gallery.length - 1;
        }
        setGalleryElem(index);
    }

    function nextImg() {
        let index = galleryElem + 1;
        if (index >= gallery.length) {
            index = 0;
        }
        setGalleryElem(index);
    }

    return (
        <>
        {galleryElem?
        <div className={"px-7 pt-7 is-flex-grow-1 flow flow--large slide-gallery-mob "+classConvert(group)}>
            <img src={domain+gallery[galleryElem].image} alt="" width="313" height="208"/>
            <h1 className="is-size-6 is-family-secondary">{parse(gallery[galleryElem].footprint)}</h1>
            <p>{parse(gallery[galleryElem].description)}</p>
            <div className="is-flex is-align-items-center is-justify-content-space-between gap-3 mb-5">
                <button onClick={(event) => {event.preventDefault();prevImg()}} type="button" className="button is-text p-0 is-flex-shrink-0" disabled="">
                    <img loading="lazy" src={IcoNext} alt={translate('Anterior')} width="59" height="42"/>
                </button>
                <button onClick={(event) => {event.preventDefault();nextImg()}} type="button" className="button is-text p-0 is-flex-shrink-0">
                    <img loading="lazy" src={IcoPrev} alt={translate('Següent')} width="59" height="42"/>
                </button>
            </div>
        </div>
        :
        <div className={"px-7 is-flex-grow-1 "+ classConvert(group)}>
            <h2 className="has-text-centered is-size-7 my-7">{translate('Galeria d\'imatges')}</h2>
            <div className="gallery-mob is-flex is-flex-direction-column gap-5 mb-7">
                {gallery.map((image, index) =>
                <Link key={index} to="" onClick={(event) => {
                    event.preventDefault();
                    setGalleryElem(index);
                    }}>
                    <img loading="lazy" src={domain+image.image} width="312" height="208" className="is-flex" alt=""/>
                </Link>
                )}
            </div>
        </div>
        }
        </>
    )
}
